'use es6';

import http from 'hub-http/clients/apiClient';
import { createGetAllDealPipelinesWithPermissions } from '../api/PipelinesWithPermissionsAPI';
import { createDealPipelinesReferenceResolver } from './DealPipelinesReferenceResolver';
const getAllDealPipelines = createGetAllDealPipelinesWithPermissions({
  httpClient: http
});
export const createDealPipelinesWithPermissionsReferenceResolver = options => createDealPipelinesReferenceResolver(Object.assign({
  createFetchData: createGetAllDealPipelinesWithPermissions,
  fetchData: getAllDealPipelines
}, options));
export default createDealPipelinesWithPermissionsReferenceResolver();